import { useState } from "react"
import {
  HStack,
  Spacer,
  Stack,
} from "@chakra-ui/react"
import { DollarInput, Text } from "@/components"
import { STATES } from "@/constants"
import { format } from "@/utils"

interface Props {
  income: number
  fmv: number
  handleIncomeChange: (value: number) => any
  handleStateChange: (value: string) => any
  handleMarriedStatusChange: (value: string) => any
  handleCurrentFmvChange: (value: number) => any
}

export const TaxDetailsComponent = ({
  income,
  fmv,
  handleIncomeChange,
  handleStateChange,
  handleMarriedStatusChange,
  handleCurrentFmvChange
}: Props) => {
  const [currentState, setCurrentState] = useState<string>("")
  const [clientMarriedStatus, setClientMarriedStatus] = useState<string>("No")

  const handleClientMarriedStatusChange = (value: string) => {
    setClientMarriedStatus(value)
    handleMarriedStatusChange(value)
  }

  const handleCurrentStateChange = (value: string) => {
    setCurrentState(value)
    handleStateChange(value)
  }
  return (
    <Stack>
      <Text fontSize="lg" fontWeight="bold">Additional Tax Info</Text>
      <Text fontSize="sm" color="gray.500" pb={10}>Fill out the information below for the tax year of your exercise</Text>
      <HStack gap={3}>
        <Spacer />
        <Stack borderRadius={10} bg="white" p={5}>
          <Text>Current Income</Text>
          {/* <DollarInput value={format(String(income.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')))} setValue={(value) => handleIncomeChange(parseFloat(value))} /> */}
        </Stack>
        <Stack borderRadius={10} bg="white" p={5}>
          <Text>State</Text>
          <select
            value={currentState}
            onChange={(e) => handleCurrentStateChange(e.target.value)}
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "6px 10px",
              outline: "none",
            }}
          >
            <option value="">-- Select --</option>
            {STATES.map((state: string) => {
              return (
                <option key={state} value={state}>
                  {state}
                </option>
              )
            })}
          </select>
        </Stack>
        <Stack borderRadius={10} bg="white" p={5}>
          <Text>Married?</Text>
          <select
            value={clientMarriedStatus}
            onChange={(e) => handleClientMarriedStatusChange(e.target.value)}
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "6px 10px",
              outline: "none",
            }}
          >
            <option key={"No"} value={"No"}>
              No
            </option>
            <option key={"Yes"} value={"Yes"}>
              Yes
            </option>
          </select>
        </Stack>
        <Stack borderRadius={10} bg="white" p={5}>
          <Text>Current FMV</Text>
          {/* <DollarInput value={format(String(fmv))} setValue={(value: string) => handleCurrentFmvChange(parseFloat(value))} /> */}
        </Stack>
        <Spacer />
      </HStack>
    </Stack>
  )
}